export const PROJECT_ID = 'b9dc1b00-78e3-009e-2f3e-e73b815cfbf3';
export const PREVIEW_API_KEY = process.env.REACT_APP_PREVIEW_API || '';

export const KENTICO_TYPES = {
  AWARD: 'nagroda',
  BOARD_OF_DIRECTORS: 'czlonek_rady_nadzorczej',
  BOX: 'box',
  CASE_STUDY: 'case_study',
  CHART_ELEMENT: 'wykres_element',
  CALENDARIUM: 'artykul_w_calendarium',
  COMMENT: 'komentarz',
  COMPANY: 'spolka',
  COMPANY_LOGO: 'logo_spolki',
  COMPANY_INFO_BOX: 'wybrana_spolka_info_box',
  COUNTRY: 'kraj',
  CURRENT_REPORTS: 'artykul_w_current_reports',
  ENTERPRISE: 'inicjatywa_grupa',
  EVENT: 'wydarzenie',
  FILE: 'plik',
  HISTORY: 'historia',
  JOB_OFFER: 'oferta_pracy',
  JOB_OFFER_CONTENT: 'oferta_pracy_tresc_strony',
  LINK: 'link',
  MANAGEMENT: 'czlonek_zarzadu',
  MISSION_AND_VISION_BIG_BOX: 'misja_i_wizja_big_box',
  NEWS: 'aktualnosci',
  OFFICE: 'biuro',
  PARTNER: 'partner',
  PERSON: 'pracownik',
  PRESS_ARTICLE: 'artykul_prasowy',
  PRESS_ROOM_NEWS: 'artykul_w_press_room',
  PRODUCT: 'produkt',
  PANEL: 'panel',
  REPORT: 'raport',
  REPORT2: 'raport2',
  REPORT3: 'raport3',
  RISK_AND_THREAT: 'opis_ryzyk_i_zagrozen',
  SERVICE: 'usluga',
  SOURCE_OF_INCOME: 'zrodlo_dochodu',
  SPECIALIZATION: 'specjalizacja',
  SIMPLE_CASE_STUDY: 'prosty_case_study',
  SHAREHOLDERS_STRUCTURE: 'struktura_akcjonariatu',
  TEAM_OF_EXPERTS: 'zespol_ekspertow',
  TWO_COLUMNS_PANEL: 'two_columns_panel',
  TRANSLATE: 'tlumaczenia',
  VIDEO_COMMENT: 'raport___komentarz_video',
  CONTENT: 'tenderhutcontent',
  FINANCIAL_RESULTS: 'wyniki_finansowe',
  SEO: 'seo',
  FOR_INVESTORS: 'dla_inwestorow',
  FOR_INVESTORS_NEWS: 'dla_inwestorow___aktualnosci',
  FOR_INVESTORS_EVENT: 'dla_inwestorow___wydarzenia',
  FOR_INVESTORS_UPCOMING_EVENTS: 'dla_inwestorow___nadchodzace_wydarzenia',
  GENERAL_MEETINGS: 'artykul_w_walne_zgromadzenia',
  PERIODIC_REPORTS: 'artykul_w_raporty_okresowe',
  LANDING_PAGE_JOB_OFFER: 'landing_page___oferty_pracy',
  GLOBAL_META_TAGS: 'global_meta_tags',
  GLOBAL_META_TAG: 'global_meta_tag_element',
  ISSUE_OF_SHARES: 'emisja_akcji',
  PRESENTATIONS: 'prezentacje_inwestorskie'
};

export const SETTINGS = {
  DEFAULT_LIMIT: 10
};



// WEBPACK FOOTER //
// ./src/common/consts/kentico.js